import * as React from 'react';
import { useCallback } from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { Money as MoneyComponent } from '../../../Money';
import { Switch } from '@shared/ui';
import { useIsMobile } from '../../../utils';
const SwitchBlock = ({ price, className, onChange, variant, isActive, isDisabled, isOld, isLoading }) => {
    const { SwitchBlock: css } = useTheme('FareLock');
    const { t } = useTranslation('FareLock');
    const label = variant === 'FareLock' ? t('Lock fare') : t('Ticket refund');
    const isMobile = useIsMobile();
    const isSwitchAside = isOld && !isMobile;
    const isInvertedSwitch = variant === 'FareLock' && isActive && !isOld;
    const onClick = useCallback(() => {
        if (onChange) {
            onChange(!isActive);
        }
    }, [isActive, onChange]);
    const switchElement = (React.createElement(Switch, { classes: { root: css.switch_root }, checked: isActive, onChange: onClick, disabled: isDisabled, inverted: isInvertedSwitch, loading: isLoading }));
    return (React.createElement("div", { className: cn(css.root, className, {
            [css.root_old]: isOld,
            [css.root_disabled]: isDisabled,
            [css.root_refund]: variant === 'Refund'
        }) },
        React.createElement("div", { className: css.info },
            React.createElement("div", { className: css.actionText },
                React.createElement("span", null, label),
                !isSwitchAside && React.createElement("span", null, ","),
                isSwitchAside && switchElement),
            React.createElement("div", { className: css.price_wrapper },
                React.createElement("div", { className: css.price_label }, t('only')),
                React.createElement("div", { className: css.price },
                    React.createElement(MoneyComponent, { money: price })))),
        !isSwitchAside && React.createElement("div", { className: css.switch_wrapper }, switchElement)));
};
export default SwitchBlock;
